import Vue from 'vue'
import JoinMeeting from './components/JoinMeeting'
import router from './router'; // 引入路由器
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router, // 使用路由器
  render: h => h(JoinMeeting),
}).$mount('#app');

// 监听路由的变化并更新 document 的 <title>
router.afterEach(to => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
});